import styled from 'styled-components'

export default styled.div`
border: 1px solid #ddd;
cursor: pointer;
padding: 0.5em 0.75em;
color: #ddd;
margin: 4px 0;
`
